// extracted by mini-css-extract-plugin
export default {"icon--disabled":"PickupStoreStockIcon_icon--disabled__59VEi"};